import { API_BASE_URL, API_DUMMY_RESULT, STRIPE_PLAN_OBJ } from '@/config/constants'
import * as dummy from './authDummy'
import axios from 'axios'

const roleTable = [
  { key: 'Owner', id: 1 },
  { key: 'Admin', id: 2 },
  { key: 'Member', id: 3 },
]

const purchaseTypeTable = [
  { key: 'DirectSales', id: 1 },
  { key: 'PartnerSales', id: 2 },
  { key: 'PartnerReferral', id: 3 },
  { key: 'Self', id: 4 },
  { key: 'Discount', id: 2 }
]

const licenseTable = [
  { key: 'Standard', id: 1, planId: STRIPE_PLAN_OBJ.Standard },
  { key: 'Trial', id: 2, planId: STRIPE_PLAN_OBJ.Trial },
  { key: 'Free', id: 3, planId: STRIPE_PLAN_OBJ.Free },
]

const normalHeader = {
  headers: {
    'Content-Type': 'application/json'
  }
}

const getBearerAuthHeader = (accessToken: string) => {
  return {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    }
  }
}

const getAuthHeader = (uid: string) => {
  return {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': uid
    }
  }
}

export const setGsuiteAuth = async ({uid, email, locale, accessToken, refreshToken, log}: any) => {
  const url = `${API_BASE_URL}/authentication/gsuite/signin`
  const d = {
    uid,
    email,
    locale,
    access_token: accessToken,
    refresh_token: refreshToken,
    log
  }
  return await axios.post(url, d, normalHeader).then((res) => {
    const role = roleTable.find((obj) => obj.id === res.data?.role)
    return {
      isAbejaAdmin: !res.data?.is_admin ? false : true,
      role: !role ? 'Member' : role.key,
    }
  }).catch((err) => {
    return Promise.reject(err)
  })
}

export const setMicrosoftAuth = async ({uid, email, locale, accessToken, refreshToken, log}: any) => {
  const url = `${API_BASE_URL}/authentication/office365/signin`
  const d = {
    uid,
    email,
    locale,
    access_token: accessToken,
    refresh_token: refreshToken,
    log
  }
  return await axios.post(url, d, normalHeader).then((res) => {
    const role = roleTable.find((obj) => obj.id === res.data?.role)
    return {
      isAbejaAdmin: !res.data?.is_admin ? false : true,
      role: !role ? 'Member' : role.key,
    }
  }).catch((err) => {
    return Promise.reject(err)
  })
}

export const getMicrosoftUserInfo = async ({accessToken}: any) => {
  const url = 'https://graph.microsoft.com/v1.0/me'
  const header = await getBearerAuthHeader(accessToken)
  return await axios.get(url, header)
}

export const getUserAuth = async (uid: string) => {
  const url = `${API_BASE_URL}/authentication/user`
  const header = await getAuthHeader(uid)
  if (API_DUMMY_RESULT) {
    return dummy.user
  }
  return axios.post(url, {}, header).then((res) => {
    const role = roleTable.find((obj) => obj.id === res.data?.role)
    return {
      customerName: res.data?.customer_name || '',
      isAbejaAdmin: !res.data?.is_admin ? false : true,
      role: !role ? 'Member' : role.key
    }
  })
}

export const getCustomerSetting = async (uid: string) => {
  const url = `${API_BASE_URL}/management/customer`
  const header = await getAuthHeader(uid)
  if (API_DUMMY_RESULT) {
    return dummy.customer
  }
  return axios.get(url, header).then((res) => {
    const purchaseType = purchaseTypeTable.find((obj) => obj.id === res.data?.customer.purchase_type)
    return {
      name: res.data?.customer.name || '',
      customerId: res.data?.customer.customer_id || null,
      country: res.data?.customer.country || '',
      externalServiceId: res.data?.customer.external_service_id || null,
      phone: res.data?.customer.phone || '',
      postCode: res.data?.customer.post_code || '',
      purchaseType: purchaseType?.key || '',
      representativeUserName: res.data?.customer.representative_user_name || '',
      address: res.data?.customer.street_address || '',
    }
  })
}

export const updateCustomerSetting = async (uid: string, data: any) => {
  const url = `${API_BASE_URL}/management/customer`
  const header = await getAuthHeader(uid)
  const purchaseType = purchaseTypeTable.find((obj) => obj.key === data.purchaseType)
  const d = {
    customer_id: data.customerId,
    name: data.name,
    country: data.country,
    street_address: data.address,
    post_code: data.postCode,
    phone: data.phone,
    representative_user_name: data.representativeUserName,
    purchase_type: purchaseType ? purchaseType.id : 1,
    external_service_id: data.externalServiceId,
  }
  return axios.put(url, d, header)
}

export const loadLicenseList = async (uid: string) => {
  const url = `${API_BASE_URL}/management/licenses`
  const header = await getAuthHeader(uid)
  if (API_DUMMY_RESULT) {
    return dummy.licenseList
  }
  return axios.get(url, header).then((res) => {
    return res.data.data.map((arr: any) => {
      const licenseType = licenseTable.find((obj) => obj.id === arr.license_type)
      const purchaseType = purchaseTypeTable.find((obj) => obj.id === arr.purchase_type)
      return {
        paymentDate: arr.payment_date,
        orderId: arr.order_id,
        customerId: arr.customer_id,
        customerName: arr.customer_name,
        licenseType: licenseType?.key || '',
        // licenseTypeName: arr.license_type_name,
        purchaseType: purchaseType?.key || '',
        // purchaseTypeName: arr.purchase_type_name,
        numberOfLicense: arr.number_of_license,
        numberOfUsingLicense: arr.number_of_using_license
      }
    })
  }).catch((err) => {
    return Promise.reject(err)
  })
}

export const loadAdminLicenseList = async (uid: string) => {
  const url = `${API_BASE_URL}/admin/inquiry-licenses`
  const header = await getAuthHeader(uid)
  if (API_DUMMY_RESULT) {
    return dummy.adminLicenseList
  }
  return axios.get(url, header).then((res) => {
    return res.data.data.map((arr: any) => {
      const licenseType = licenseTable.find((obj) => obj.id === arr.license_type)
      const purchaseType = purchaseTypeTable.find((obj) => obj.id === arr.purchase_type)
      return {
        paymentDate: arr.payment_date,
        orderId: arr.order_id,
        customerId: arr.customer_id,
        customerName: arr.customer_name,
        licenseType: licenseType?.key || '',
        // licenseTypeName: arr.license_type_name,
        purchaseType: purchaseType?.key || '',
        // purchaseTypeName: arr.purchase_type_name,
        numberOfLicense: arr.number_of_license,
        numberOfUsingLicense: arr.number_of_using_license
      }
    })
  }).catch((err) => {
    return Promise.reject(err)
  })
}
export const loadAdminSelectedCustomer = async (uid: string, name: string) => {
  const url = `${API_BASE_URL}/admin/licenses`
  const header = await getAuthHeader(uid)
  const d = { name }
  if (API_DUMMY_RESULT) {
    return dummy.selectedCustomer(name)
  }
  return axios.get(url, Object.assign(header, { params: d }))
}
export const updateAdminCustomerSetting = async (uid: string, data: any) => {
  const url = `${API_BASE_URL}/admin/licenses/${data.customerId}/update`
  const header = await getAuthHeader(uid)
  const purchaseType = purchaseTypeTable.find((obj) => obj.key === data.purchaseType)
  const d = {
    name: data.name,
    street_address: data.address,
    post_code: data.postCode,
    phone: data.phone,
    representative_user_name: data.representativeUserName,
    country: data.country,
    external_service_id: data.externalServiceId,
    purchase_type: purchaseType ? purchaseType.id : 1,
  }
  return axios.put(url, d, header)
}

export const savePurchasedLicense = async (uid: string, cardToken: string, licenseType: string, count: number) => {
  const url = `${API_BASE_URL}/management/customer/subscription`
  const header = await getAuthHeader(uid)
  const license = licenseTable.find((obj) => obj.key === licenseType)
  const d = {
    card_token: cardToken,
    plan_id: license ? license.planId : null,
    license_type: license ? Number(license.id) : null,
    purchase_count: Number(count)
  }
  return axios.post(url, d, header)
}

export const saveAdminPurchasedLicense = async (uid: string, data: any) => {
  const url = `${API_BASE_URL}/admin/licenses/${data.customerId}/buy`
  const purchaseType = purchaseTypeTable.find((obj) => obj.key === data.purchaseType)
  const header = await getAuthHeader(uid)
  const d = {
    license_type: purchaseType ? purchaseType.id : 1,
    purchase_count: data.count
  }
  return axios.post(url, d, header)
}
